import { createGlobalStyle } from 'styled-components';

const ImgGlobalStyle = createGlobalStyle`
  img {
    max-width: 100%;
    height: auto;
  }
`;

export default ImgGlobalStyle;
